import ModalBasic from '../../../../shared/Modal/ModalBasic';
import { PrescriptionRenewalModalStep } from '../../../../../entities/PrescriptionRenewal';
import { PrescriptionRenewalResponse } from '../../../../../services/prescriptionRenewal.service';
import PrescriptionRenewalModalViewModel from './viewModel';
import TermsStep from './TermsStep';
import PrescriptionRenewalFormStep from './OrderFormStep';
import SuccessStep from './SuccessStep';
import FailureStep from './FailureStep';

type PrescriptionRenewalModalProps = {
  open: boolean;
  onClose: () => void;
  onOrderCreated: (order: PrescriptionRenewalResponse) => void;
};

export default function PrescriptionRenewalModalView({ open, onClose, onOrderCreated }: PrescriptionRenewalModalProps) {
  const vm = PrescriptionRenewalModalViewModel({ onClose, onOrderCreated });

  const renderStep = () => {
    switch (vm.step) {
      case PrescriptionRenewalModalStep.TERMS:
        return (
          <TermsStep
            accepted={vm.termsAccepted}
            onToggleAccept={vm.handleToggleAccept}
            onContinue={vm.handleContinue}
            isChecking={vm.isCheckingEligibility}
          />
        );
      case PrescriptionRenewalModalStep.ORDER_FORM:
        return (
          <PrescriptionRenewalFormStep
            doctors={vm.doctors}
            selectedDoctorId={vm.selectedDoctorId}
            description={vm.description}
            onDoctorChange={vm.handleDoctorChange}
            onDescriptionChange={vm.handleDescriptionChange}
            onSubmit={vm.handleSubmit}
            canSubmit={vm.canSubmitOrder}
            isSubmitting={vm.isSubmitting}
          />
        );
      case PrescriptionRenewalModalStep.SUCCESS:
        return <SuccessStep />;
      case PrescriptionRenewalModalStep.FAILURE:
        return <FailureStep errorType={vm.errorSubmit} />;
      default:
        return null;
    }
  };

  return (
    <ModalBasic open={open} onCloseHandler={vm.handleClose}>
      {renderStep()}
    </ModalBasic>
  );
}
